import request from '@/utils/request'

// 获取路由
export const getDeptList = (params) => {
    return request({
        url: '/bosc/api/SysDept/selectDeptList',
        method: 'post'
      })
}
export const checkteDept = (id) => {
  return request({
    url: `/bosc/api/SysDept/selectDeptById/${id}`,
    method: 'get'
  })
}
export const createDept = (data) => {
  return request({
    url: `/bosc/api/SysDept/insertDept`,
    method: 'post',
    data:data
  })

}
export const DeleteDeptId = (id) => {
  return request({
    url:`/bosc/api/SysDept/deleteSysDeptByDeptId/${id}`,
    method: 'get'
  })
}

export const inviteDept = (data) => {
  return request({
    url:`/bosc/api/sysApplyDept/inviteDept`,
    method: 'post',
    params: data
    // data
  })
}

export const applyDept = (data) => {
  return request({
    url:`/bosc/api/sysApplyDept/applyDept`,
    method: 'post',
    params: data
    // data
  })
}

export const updateSysUser = (data) => {
  return request({
    url:`/bosc/api/sysUser/updateSysUser`,
    method: 'post',
    // params: data,
    data
  })
}

export const approvalList = (data) => {
  return request({
    url:`/bosc/api/sysApplyDept/approvalList`,
    method: 'post',
    params: data
  })
}

export const approvalStatus = (data) => {
  return request({
    url:`/bosc/api/sysApplyDept/approvalStatus`,
    method: 'post',
    params: data
  })
}

export const logoutAPI = () => {
  return request({
    url:`/bosc/api/logOut`,
    method: 'get'
  })
}

export const deleteCodeServerAPI = () => {
  return request({
    url:`/bosc/api/docker/deleteCodeServer`,
    method: 'get'
  })
}

export const updateLogoutTime = () => {
  return request({
    url:`/bosc/api/sysUser/updateTime`,
    method: 'get'
  })
}